import styled from "styled-components";

import { Metrics, Palette } from "../../vars";

const ToolbarDivider = styled.div`
  height: 100%;
  width: ${Metrics.Widths.TOOLBAR_ITEM_DIVIDER}px;
  background-color: ${Palette.TOOLBAR_ITEM_DIVIDER};
`;

export default ToolbarDivider;
